<i18n>
zh: 
    link: 友情链接
    contact: 联系我们
ru:
    link: Связь дружбы
    contact: Свяжись с нами.
</i18n>
<template>
    <div class="footer">
        <div class="select_wrap" v-if="config.links && config.links.length > 0">
            <div class="container">
                <div class="title">{{$t('link')}} :</div>
                <div class="select_group">
                    <template v-for="item in config.links">
                        <FooterSelect :data='item' :key="item.id"/>
                    </template>
                </div>
            </div>
        </div>
        <div class="contact">
            <div class="container">
                <div class="l">
                    <div class="title">
                        <p class="text1">CONTACT US</p>
                        <p>{{$t('contact')}}</p>
                    </div>
                    <div class="info">
                        <div class="item">
                            <div class="icon address"></div>
                            <p>{{config.address}}</p>
                        </div>
                        <div class="item">
                            <div class="icon tel"></div>
                            <p>{{config.phone}}</p>
                        </div>
                        <div class="item">
                            <div class="icon"></div>
                            <p>Copyright(C) www.jienengredian.com All Rights Reserved</p>
                        </div>
                    </div>
                    <img class="qrcode" src="@/assets/images/8_20.jpg" alt=""/>
                </div>
                <div class="r">
                    <img src="@/assets/images/8_50.jpg" alt=""/>
                    <img src="@/assets/images/8_20.jpg" alt=""/>
                </div>
                <div class="bottom">Copyright(C) www.jienengredian.com All Rights Reserved&nbsp;&nbsp;&nbsp;&nbsp;邮编：1013 备案号: 黑ICP备19000544号-1</div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import FooterSelect from './footerSelect.vue';
export default {
    name: "Footer",
    data() {
        return {};
    },
    computed: {
        ...mapState(['config']),
    },
    components: {
        FooterSelect
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<style scoped lang="scss">
.select_wrap{
    background: #3f87cf;
    padding: 20px 0;
    .container{
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .title{
        margin-right: 30px;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        line-height: 1;
    }
    .select_group{
        display: flex;
    }
    @media only screen and (max-width: 1024px) {
        padding: .3rem 0;
        .title{
            margin-right: .3rem;
            font-size: .2rem;
        }
    }
}
.contact{
    background: #075293;
    padding: 40px 0;
    color: #fff;
    .container{
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
    }
    .r{
        display: flex;
        img{
            width: 70px;
            border: 4px solid #fff;
            box-sizing: content-box;
            margin-left: 10px;
        }
    }
    .l{
        display: flex;
        .title{
            font-size: 20px;
            font-weight: bold;
            font-family: "微软雅黑";
            line-height: 1;
            .text1{
                font-size: 35px;
                margin-bottom: 10px;
            }
        }
        .info{
            margin-left: 255px;
            font-size: 14px;
            line-height: 2;
            .item{
                display: flex;
                align-items: center;
                .icon{
                    width: 20px;
                    height: 20px;
                    background-repeat: no-repeat;
                    background-position: center;
                    margin-right: 5px;
                    &.address{
                        background-image: url('~@/assets/images/1_39.png');
                    }
                    &.tel{
                        background-image: url('~@/assets/images/1_43.png');
                    }
                }
            }
        }
        .qrcode{
            display: none;
        }
    }
    .bottom{
        display: none;
    }
    @media only screen and (max-width: 1024px) {
        padding: .5rem;
        .container{
            display: block;
        }
        .l{
            .title{
                text-align: right;
                font-size: .2rem;
                .text1{
                    font-size: .35rem;
                    margin-bottom: 10px;
                }
            }
            .info{
                display: none;
            }
            .qrcode{
                display: block;
                width: 1rem;
                height: 1rem;
                border: .06rem solid #fff;
                margin-left: .4rem;
            }
        }
        .r{
            display: none;
        }
        .bottom{
            display: block;
            font-size: .12rem;
            text-align: center;
            margin: .5rem -.5rem 0;
        }
    }
}
</style>